import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { SEO } from "@/components/SEO/SEO";
import * as _ from "lodash";
import toast from "react-hot-toast";

import { useProductStore } from "@/_zustand/store";
import { useMachine } from "@/_zustand/machine";
import { formatMoney } from "@/lib";
import { useProductCart } from "@/_zustand/productCart";

import { NavBar } from "../home/components/NavBar";

export const ProductPage = () => {
  const navigate = useNavigate();
  const { product } = useProductCart();
  const { addToCart, calculateTotals, products, setStoreToPay, allQuantity } =
    useProductStore();
  const {
    machineSelected,
    addressMachine,
    nameEmpresa,
    logoMachine,
    empresa_id,
  } = useMachine();
  const [quantityCount, setQuantityCount] = useState(1);

  useEffect(() => {
    if (_.size(product) > 0) {
      let findStorage = products.find(
        (item) =>
          item.producto_id === product.producto_id &&
          machineSelected === item.maquina_id,
      );

      if (_.size(findStorage) > 0) {
        setQuantityCount(findStorage.producto_cant);
      }
    }
  }, [product, machineSelected, products]);

  if (_.size(product) === 0) {
    return (
      <div>
        <h1>Producto no encontrado</h1>
      </div>
    );
  }

  const handleQuantityChange = (actionName) => {
    if (actionName === "plus") {
      setQuantityCount(() => quantityCount + 1);
    } else if (actionName === "minus" && quantityCount !== 1) {
      setQuantityCount(() => quantityCount - 1);
    }
  };

  const handleAddToCart = () => {
    let dataToAdd = {
      ...product,
      producto_cant: quantityCount,
      maquina_id: machineSelected,
      logo_machine: logoMachine,
      name_empresa: nameEmpresa,
      address_machine: addressMachine,
      empresa_id: empresa_id,
    };
    addToCart(dataToAdd, machineSelected);
    setStoreToPay(machineSelected);
    calculateTotals(machineSelected);
    toast.success("Producto agregado al carrito");
    return navigate(`/store/${machineSelected}`, { replace: true });
  };

  const handlePay = () => {
    setStoreToPay(machineSelected);
    calculateTotals(machineSelected);
  };

  const ButtonPay = () => {
    if (allQuantity) {
      return (
        <Link to="/cart">
          <Button
            className="btn btn-secondary rounded btn-large px-5 verde"
            onClick={handlePay}
          >
            Ir a pagar
          </Button>
        </Link>
      );
    }

    return <></>;
  };

  return (
    <section id="producto" className="container my-5">
      <SEO
        title="Producto"
        description="Detalle del producto disponible en OpenMatic."
        url="/product"
      />
      <NavBar addressMachine={addressMachine} nameEmpresa={nameEmpresa} />

      <div className="row d-flex justify-content-center">
        <div className="col-md-4 col-12 mb-md-0 p-md-4">
          <img
            className="card-image"
            src={product.producto_foto}
            alt={product.producto_nombre}
            width="400"
          />
        </div>
        <div className="col-md-6 p-4 ps-md-0">
          <h5
            className="mt-0 text-black inter-bold color-gris"
            style={{ fontSize: "34px" }}
          >
            {product.producto_nombre}
          </h5>
          <h4 className="text-black inter-semibold font36">
            {formatMoney(product.producto_precio)}
          </h4>

          <p className="inter-regular font16">
            Ofrecemos una garantía de <strong>un año</strong> en caso de que
            haya algún problema con nuestros productos.
          </p>
          <hr />
          <div className="font16 text-black">
            <p>Cantidad ML</p>
            <input type="radio" className="btn-check" checked />
            <label className="btn btn-outline-secondary" htmlFor="option2">
              {product.cantidad}
            </label>
          </div>
          <hr />

          <div className="container-fluid mx-0">
            <div className="row d-flex">
              <div className="col-md-6 font16 inter-regular text-black-50 p-2">
                <div className="d-flex align-items-center">
                  <span>Cantidad</span>
                  <Button
                    variant="outline-secondary"
                    className="mx-2"
                    onClick={() => handleQuantityChange("minus")}
                  >
                    -
                  </Button>
                  <input
                    type="text"
                    id="quantityInput"
                    className="form-control text-center me-2"
                    value={quantityCount}
                    readOnly
                  />
                  <Button
                    variant="outline-secondary"
                    className="ms-2"
                    onClick={() => handleQuantityChange("plus")}
                  >
                    +
                  </Button>
                </div>
              </div>
              <div className="col-md-6 font16 inter-regular text-black-50 text-center p-2">
                <Link
                  to={``}
                  className="btn border rounded-pill border-dark"
                  onClick={handleAddToCart}
                >
                  <i className="fa-solid fa-cart-shopping"></i> Agregar al
                  carrito
                </Link>
              </div>
            </div>
            <hr />
          </div>
          <div className="container-fluid ">
            <div className="row d-flex justify-content-start">
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 p-2 text-center">
                <ButtonPay />
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 p-2 text-center">
                <Link to={`/store/${machineSelected}`} className="">
                  <Button className="btn btn-secondary rounded">
                    Seguir comprando
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-2"></div>
      </div>
      <div className="row-cols-3 container">
        <div className="col-12 color-gris">
          <div className="border border-1 rounded p-4">
            <div className="inter-medium">
              <h5 style={{ fontSize: "18px" }}>Descripción</h5>
              <p style={{ fontSize: "16px" }}>{product.producto_descripcion}</p>
              <hr />
            </div>
            <div>
              <h5 style={{ fontSize: "18px" }}>Detalles de Producto</h5>
              <table id="productDetail">
                <tbody>
                  {product.marca_id && (
                    <tr>
                      <td>Marca</td>
                      <td>{product.marca_nombre}</td>
                    </tr>
                  )}
                  {product.producto_codigo && (
                    <tr>
                      <td>Género </td>
                      <td> {product.genero_nombre}</td>
                    </tr>
                  )}
                  {/* <tr>
                  <td>Aroma</td>
                  <td>Floral</td>
                </tr>
                <tr>
                  <td>Ocasión</td>
                  <td>Día</td>
                </tr>
                <tr>
                  <td>Temporada</td>
                  <td>Promavera</td>
                </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
